import { ApiV3 } from '../../commonv3/api/ApiV3';
import { MembershipPlanGroupKey } from '../types/membershipPlans';
import { SessionType } from '../types/sessions';
import { MainV3ApiBase } from './base';

type SessionTemplateParams = {
  session_type: SessionType;
  current_service: MembershipPlanGroupKey;
};

export const SessionTemplateApis = {
  base(): ApiV3 {
    return MainV3ApiBase.appendPath('session_templates');
  },
  findAll(params: SessionTemplateParams) {
    return this.base().get(params);
  },
};
